(function () {
    'use strict';

    angular
        .module('harriApp')
        .service('commshubService', CommshubService);

    function CommshubService($q) {
        var self = this;
        var _emitter = JarEventEmitter.call(self);

        var _unreadMessagesCount;
        var _brandsUnreadMessagesCount = {};

        self.getEmployerUnreadMessagesCount = function () {
            var defer = $q.defer();
            if (!isNaN(_unreadMessagesCount)) {
                defer.resolve(_unreadMessagesCount);
            } else {
                TeamCommunicationAPI.getUnreadMessagesCount()
                    .then(function (count) {
                        _unreadMessagesCount = count;
                        defer.resolve(_unreadMessagesCount);
                    });
            }

            return defer.promise;
        };

        self.getEmployeeUnreadMessagesCount = function (brandId) {
            var defer = $q.defer();
            if (!isNaN(_brandsUnreadMessagesCount[brandId])) {
                defer.resolve(_brandsUnreadMessagesCount[brandId]);
            } else {
                TeamCommunicationAPI.getEmployeeUnreadMessagesCount(brandId)
                    .then(function (count) {
                        _brandsUnreadMessagesCount[brandId] = count;
                        defer.resolve(_brandsUnreadMessagesCount[brandId]);
                    });
            }

            return defer.promise;

        };

        self.reset = function () {
            _brandsUnreadMessagesCount = {};
            _unreadMessagesCount = undefined;
        };

        self.triggerUnreadMessagesChanged = function () {
            _emitter.trigger('unread_messages_changed');
        };
    }


    CommshubService.$inject = ['$q'];

})();
